<a mat-list-item (click)="toggle()" >
    <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}">
        <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Secretaria">
            <mat-icon>contact_phone</mat-icon>
            <span *ngIf="menuPrincipalService.expandido"  class="nav-caption">Secretaria</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start stretch">
            <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
        </div>
    </div>
</a>
<mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

    <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">

        <!-- FREQUÊNCIA NA UNIDADE -->
        <sub-menu *ngIf="verificaAcesso(getModulos().FREQUENCIA_ALUNO_UNIDADE)" icone="face" titulo="Frequência na Unidade" rota="frequenciaalunounidade" toolTip="Frequência de Beneficiários na Unidade"></sub-menu>

        <!-- ALUNO -->
       <sub-menu *ngIf="verificaAcesso(getModulos().ALUNO)" icone="face" titulo="Beneficiário" rota="aluno" toolTip="Beneficiário"></sub-menu>

        <!-- FAMILIAR -->
       <sub-menu *ngIf="verificaAcesso(getModulos().FAMILIAR_ALUNO)" icone="supervised_user_circle" titulo="Cadastro Familiar" rota="familiaraluno" toolTip="Cadastro Familiar"></sub-menu>

        <!-- UNIFORME ENTREGUE -->
        <sub-menu *ngIf="verificaAcesso(getModulos().UNIFORME_ENTREGUE_ALUNO)" icone="wc" titulo="Uniforme Entregue ao Beneficiário" rota="uniformeentregue" toolTip="Uniforme Entregue ao Beneficiário"></sub-menu>

        <!-- CADASTRO RESERVA -->
        <sub-menu *ngIf="verificaAcesso(getModulos().CADASTRO_RESERVA_ATIVIDADE)" icone="how_to_reg" titulo="Cadastro Reserva" rota="cadastroreservaatividade" toolTip="Cadastro Reserva"></sub-menu>

        <!-- RELATORIOS -->
        <sub-menu-relatorio></sub-menu-relatorio>

        <!-- REFERENCIA SECRETARIA -->
       <tb-referencia-secretaria></tb-referencia-secretaria>

    </div>
</mat-nav-list>
